import { useQuery } from '@tanstack/react-query';

import { fetchProfiles } from '../services/api/enrichments';

export const useProfiles = (categoryId?: number) => {
  return useQuery({
    queryKey: ['profiles'],
    queryFn: () => fetchProfiles(categoryId),
    initialData: [],
  });
};
